// extracted by mini-css-extract-plugin
export default {"row":"ResultsWrapper_row__-d-TM","rowMarginTop":"ResultsWrapper_rowMarginTop__SuRhS","rowMarginBottom":"ResultsWrapper_rowMarginBottom__-gDpK"};